module.exports = __webpack_public_path__ + "static/media/cards@3x.8089b6fc.png";